// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAsIivZ_6gAN0gYFISaUrFFJJlRSQVnteE",
    authDomain: "recreo250.firebaseapp.com",
    databaseURL: "https://recreo250.firebaseio.com",
    projectId: "recreo250",
    storageBucket: "recreo250.appspot.com",
    messagingSenderId: "801490951386",
    appId: "1:801490951386:web:ca2c5c4db62511e5ce59e3",
    measurementId: "G-1FYV1BMHBC"
  }
};
